module.exports = __webpack_public_path__ + "static/media/example.4e0bde0a.jpg";